import {first} from 'lodash-es'

/**
 * 地图数据的初始化
 * @param shopList
 * @param bizoppId
 * @returns {*}
 * 1. 地图商铺点的数据
 * 2. 地图商圈的数据
 * 3. My Location 数据
 */
function transNumber (shopList) {
  return shopList.map(item => {
    return {
      ...item,
      lng: +item.lng,
      lat: +item.lat,
      opacity: 0.5
    }
  })
}

export function getMapPageInitData (state, getters, rootGetters) {
  const {geo} = rootGetters
  const {shopList, areaList} = state
  let initData = {
    shopList,
    areaList,
    myLocation: {...geo},
    center: {...geo}
  }
  initData.shopList = transNumber(shopList)
  if (initData.shopList.length !== 0) {
    initData.center = {...initData.myLocation, ...first(initData.shopList)}
  }
  initData.areaList = areaList.map(item => {
    return {...item, sidePoi: transNumber(item['sidePoi'])}
  })
  return initData
}
